import { jsx as r, jsxs as g } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import m from "clsx";
import d from "../builders-icons/dist/systems/arrow-right.js";
import { useTracking as A, getText as x } from "../utils.js";
import i from "./action-list.module.css.js";
const v = a(
  function({ className: o, size: n = "sm", variant: s = "regular", ...t }, c) {
    return /* @__PURE__ */ r(
      "div",
      {
        className: m(
          i.actionList,
          i[s],
          i[n],
          o
        ),
        ref: c,
        ...t
      }
    );
  }
), C = a(
  function({
    as: o,
    children: n,
    className: s,
    onClick: t,
    tracking: c = !0,
    ...f
  }, L) {
    const k = o || "a", p = m(i.actionListItem, s), u = A(c);
    return /* @__PURE__ */ g(k, { ...f, onClick: (e) => {
      u({
        eventCategory: "actionlist",
        eventAction: "click",
        eventLabel: x(e.currentTarget)
      }), t && t(e);
    }, className: p, ref: L, children: [
      /* @__PURE__ */ r("div", { children: n }),
      /* @__PURE__ */ r(d, {})
    ] });
  }
), I = Object.assign(v, {
  Link: C
});
export {
  I as ActionList,
  v as ActionListComp
};
//# sourceMappingURL=action-list.js.map
